import { Component, forwardRef, input, model, output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import {
  ConstField,
  FormBuilderBase
} from '@shared/components/row-edition-form/form-builder/form-builder.model';

@Component({
  selector: 'app-hidden',
  imports: [],
  templateUrl: './hidden.component.html',
  styles: [
    `
      :host {
        display: flex;
        width: 100%;
      }
    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HiddenComponent),
      multi: true
    }
  ]
})
export class HiddenComponent implements ControlValueAccessor {
  id = input<FormBuilderBase['id']>();
  value = model.required<ConstField['const']>();
  wrapperProperty = input<string | undefined>(undefined);
  valueLoaded = output<ValuedLoadedEvent>();

  onChange = (_: unknown) => {};
  onTouched = () => {};

  onInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.onChange(value);
  }

  writeValue(value: unknown): void {
    this.valueLoaded.emit({ id: this.id() as string, value });
  }
  registerOnChange(fn: never): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: never): void {
    this.onTouched = fn;
  }
}

export interface ValuedLoadedEvent {
  id: string;
  value: unknown;
}
